<template>
    <div class="notification has-background-white-bis has-text-left mx-6" v-if="isVisible">
        <button class="delete" @click="closeBanner"></button>
        <slot/>
    </div>
  </template>

  <script>
  export default {
    props: {
        storageKey: {
            type: String,
            default: 'notificationBannerClosed'
        }
    },
    data() {
      return {
        isVisible: true
      };
    },
    created() {
        this.isVisible = localStorage.getItem(this.storageKey) !== 'true';
    },
    methods: {
      closeBanner() {
        this.isVisible = false;
        localStorage.setItem(this.storageKey, 'true');
      }
    }
  };
  </script>

  <style scoped>
  .notification {
    margin-bottom: 1rem;
  }
  </style>
